var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5128_7918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 25.667a2.34 2.34 0 0 0 2.333-2.333h-4.666A2.333 2.333 0 0 0 14 25.667m7-7v-5.833c0-3.582-1.913-6.58-5.25-7.374v-.793c0-.968-.782-1.75-1.75-1.75-.969 0-1.75.782-1.75 1.75v.793C8.9 6.254 7 9.24 7 12.834v5.833l-1.505 1.505c-.735.735-.222 1.995.816 1.995h15.366c1.038 0 1.563-1.26.828-1.995z"
  }))));
};
export default SvgBell;